import Axios from "axios";
import dayjs from "dayjs";
import React from "react";
import { DataTable } from "../data-table";
import { Spin } from "../loading";
import { Pagniation } from "../pagination";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { Button } from "@material-ui/core";
import SplitPane from "react-split-pane";

interface ProgrammeDateDataProps {
  title: string;
  subtitle: string;
  region: "ntw" | "nte" | "hki";
  tablePath: string;
  calendarPath: string;
}

const getMin = (region: "ntw" | "nte" | "hki") => {
  switch (region) {
    case "nte":
      return "2017-10";
    case "hki":
      return "2018-10";
    case "ntw":
      return "2019-10";
  }
};

interface State {
  date: string;
  prevDate: string;
  data: any[];
  loading: boolean;
  tableLoading: boolean;
  calendarData: any[];
  calendarView: any;
  showCalendarBackBtn: boolean

  paginate: {
    currentPage: number;
    total: number;
    take: number;
  };
}

const take = 10;

const initialState: State = {
  date: dayjs().subtract(2, "month").format("YYYY-MM"),
  prevDate: dayjs().subtract(2, "month").format("YYYY-MM"),
  data: [] as any[],
  loading: false,
  tableLoading: false,
  paginate: {
    currentPage: 1,
    take,
    total: Infinity,
  },
  calendarData: [] as any[],
  calendarView: Views.MONTH,
  showCalendarBackBtn: false
};

export const ProgrammeDateDataTable: React.FC<ProgrammeDateDataProps> = (props: any) => {
  const { title, subtitle, region, tablePath, calendarPath } = props;

  const [state, setState] = React.useState<State>(initialState);
  const [selectedDate, setSelectedDate] = React.useState<string | undefined>(undefined);

  const localizer = momentLocalizer(moment);

  React.useEffect(() => {
    const isNotMonth = state.prevDate === state.date;
    const isLoading = state.loading;
    const isTableLoading = state.tableLoading;
    const { date, paginate } = state;

    if (!isTableLoading || !isNotMonth) {
      setState((prev) => ({ ...prev, tableLoading: true }));
      Axios.get<[[], number]>(`/${tablePath.toLowerCase()}`, {
        params: {
          date,
          skip: (paginate.currentPage - 1) * paginate.take,
          take: paginate.take,
        },
      })
        .then((res) => {
          // if (isLoading) {
          Axios.get<[[], number]>(`/${calendarPath.toLowerCase()}`, {
            params: {
              date,
            },
          }).then((res) => {
            setState((prev) => ({ ...prev, calendarData: res.data, loading: false }));
          });
          // }
          const [data, total] = res.data;
          const { paginate } = state;
          setState((prev) => ({
            ...prev,
            data,
            paginate: {
              ...paginate,
              total,
              take,
            },
            prevDate: prev.date,
            calendarView: Views.MONTH,
            showCalendarBackBtn: false,
          }));
        })
        .finally(() => {
          setState((prev) => ({ ...prev, tableLoading: false }));
        });
    }
    console.log(state);
  // eslint-disable-next-line
  }, [state.paginate]);

  const resetCalendarView = () => {
    setSelectedDate(undefined);
    setState((prev) => ({ ...prev, calendarView: Views.MONTH, showCalendarBackBtn: false }));
  }

  const dayCalendarView = () => {
    setState((prev) => ({ ...prev, calendarView: Views.DAY, showCalendarBackBtn: true }));
  }

  const dayCalendarViewWithSelect = (date: string) => {
    setSelectedDate(date);
    setState((prev) => ({ ...prev, calendarView: Views.DAY, showCalendarBackBtn: true }));
  }

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    setState((prev) => ({
      ...prev,
      prevDate: prev.date,
      date: value,
      paginate: { ...initialState.paginate },
      loading: true
    }));
  };

  const onChange = (page: number, pageSize: number) => {
    setState((prev: any) => ({
      ...prev,
      paginate: {
        ...prev.paginate,
        currentPage: page,
        take: pageSize,
      },
    }));
  };

  return (
    <div className="date-datatable overflowHidden">
      <div className="top">
        <span className="title">{title}</span>
        <span className="subtitle">{subtitle}</span>
        <input
          type="month"
          min={getMin(region)}
          value={state.date}
          onChange={handleDateChange}
        />
        {
          (state.showCalendarBackBtn ?
            <Button variant="outlined" style={{ height: "24px" }} onClick={() => { resetCalendarView() }}>Back</Button>
            : null)
        }
      </div>

      <div className="bottom">
        <Spin spin={state.loading}>
          {state.data.length > 0 && (
            <SplitPane split="vertical" minSize={50} defaultSize="50%" style={{ position: "static" }} resizerStyle={{ cursor: 'col-resize', width: "10px" }} paneStyle={{ position: "static", overflow: "auto", height: "80%" }} pane2Style={{}}>
              <div>
                <Calendar
                  localizer={localizer}
                  style={{ height: '38em', width: '100%' }}
                  toolbar={false}
                  events={state.calendarData}
                  step={60}
                  defaultView="month"
                  view={state.calendarView}
                  views={['month', 'day']}
                  onView={(event) => { dayCalendarView() }}
                  min={new Date(state.date)}
                  max={new Date(state.date)}
                  defaultDate={new Date(state.date)}

                  date={selectedDate}
                  onSelectEvent={(event) => { dayCalendarViewWithSelect(event.start) }}
                />
              </div>
              <div>
                <Spin spin={state.tableLoading}>
                  <DataTable
                    columns={Object.keys(state.data[0]).map((key) => ({
                      title: key,
                      dataIndex: key,
                    }))}
                    data={state.data}
                  />
                  <Pagniation onChange={onChange} {...state.paginate} />
                </Spin>
              </div>
            </SplitPane>
          )}
        </Spin>
      </div>
    </div>
  );
};
